import { createEvent, restore, sample } from 'effector'
import { EditExchanger } from './types'
import { fx } from '../../../libs'
import { $params } from '../../../features/router'

export const exchangerMounted = createEvent()

export const setExchanger = createEvent<EditExchanger>()
export const submitEditExchanger = createEvent<EditExchanger>()
export const $exchanger = restore(setExchanger, {
  id: 0,
  name: '',
  frontName: '',
  internalName: '',
  active: false,
  type: '',
  owner: {
    fullName: '',
    clientId: 0,
    isTest: false,
  },
})

export const getExchanger = fx<void, EditExchanger>({
  method: 'GET',
  url: '/exchanger/',
})

export const updateExchanger = fx<EditExchanger, EditExchanger>({
  method: 'PUT',
  url: '/exchanger/',
})

sample({
  clock: exchangerMounted,
  source: $params,
  fn: (params) => {
    let id
    if (params) {
      id = params.exchangerID
    }
    return {
      query: {
        populate: JSON.stringify(['Exchanger.owner']),
      },
      url: `/exchanger/${id}`,
    }
  },
  target: getExchanger,
})

sample({
  clock: [getExchanger.doneData, updateExchanger.doneData],
  fn: (doneData) => doneData.body,
  target: [setExchanger],
})

sample({
  clock: submitEditExchanger,
  source: $params,
  fn: (params, exchanger) => {
    let id
    if (params) {
      id = params.exchangerID
    }
    return {
      query: {
        populate: JSON.stringify(['Exchanger.owner']),
      },
      url: `/exchanger/${id}`,
      body: { ...exchanger },
    }
  },
  target: updateExchanger,
})
